<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Service - Telnet Service Setup</h4>
        <el-form 
            ref="forms"
            label-width="180px" 
            label-position="left"
            class="fhv-form" 
            size="mini"
            :disabled="$G_DEVICE_CFG.isReadOnly"
            >
            <el-form-item label="Enable Telnet Service :">
                <el-switch v-model="flag" ></el-switch>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="save">Apply</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
export default {
  data() {
    return {
      flag: true,
      loading: false
    };
  },
  methods: {
    ajaxrequesthttp() {
      let postdata = {
        CmdType: "GET_TELNET"
      };
      this.loading = true;
      axios.post("/boafrm/formtelnet", postdata).then(res => {
           this.loading = false;
        let data = res.data;
        if (data == "undefined" || data == "" || data.ret == "-1") {
          this.$message.error("Data acquisition failure");
          return;
        }
        if (data.telnetSwitch == 1) {
          this.flag = true;
        } else {
          this.flag = false;
        }
      });
    },
    save() {
      if (this.flag == true) {
        var telnetSwitch = 1;
      } else {
        var telnetSwitch = 0;
      }
      let postdata = {
        CmdType: "SET_TELNET",
        telnetSwitch: telnetSwitch
      };
      this.loading = true;
      axios.post("/boafrm/formtelnet", postdata).then(res => {
           this.loading = false;
        var data = res.data;
        if (data.ret == "0") {
          this.$message.success("Configuration is successful！");
        } else {
          this.$message.error("Configuration failed!");
        }
      });
    }
  },
  created(){
      this.ajaxrequesthttp();
  }
};
</script>



